/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Ai API Specification
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { AiConfigRequest, AiConfigResponse, ApiResponseResultResponse } from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary AI config
 */
export const getV7AiConfig = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<AiConfigResponse>(
    { url: `/api/v7/ai/config`, method: 'GET', signal },
    options,
  );
};

export const getGetV7AiConfigQueryKey = () => {
  return ['api', 'v7', 'ai', 'config'] as const;
};

export const getGetV7AiConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7AiConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7AiConfig>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7AiConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7AiConfig>>> = ({ signal }) =>
    getV7AiConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7AiConfig>>,
    TError,
    TData
  >;
};

export type GetV7AiConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getV7AiConfig>>>;
export type GetV7AiConfigQueryError = ErrorType<unknown>;

/**
 * @summary AI config
 */

export function useGetV7AiConfig<
  TData = Awaited<ReturnType<typeof getV7AiConfig>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7AiConfig>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7AiConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary AI config
 */
export const patchV7AiConfig = (
  aiConfigRequest: MaybeRef<AiConfigRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  aiConfigRequest = unref(aiConfigRequest);

  return customAxiosInstance<AiConfigResponse>(
    {
      url: `/api/v7/ai/config`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: aiConfigRequest,
    },
    options,
  );
};

export const getPatchV7AiConfigMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7AiConfig>>,
    TError,
    { data: BodyType<AiConfigRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7AiConfig>>,
  TError,
  { data: BodyType<AiConfigRequest> },
  TContext
> => {
  const mutationKey = ['patchV7AiConfig'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7AiConfig>>,
    { data: BodyType<AiConfigRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV7AiConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7AiConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7AiConfig>>
>;
export type PatchV7AiConfigMutationBody = BodyType<AiConfigRequest>;
export type PatchV7AiConfigMutationError = ErrorType<unknown>;

/**
 * @summary AI config
 */
export const usePatchV7AiConfig = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7AiConfig>>,
      TError,
      { data: BodyType<AiConfigRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7AiConfig>>,
  TError,
  { data: BodyType<AiConfigRequest> },
  TContext
> => {
  const mutationOptions = getPatchV7AiConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대화 삭제
 */
export const deleteV7AiConversationsByUserId = (
  userId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  userId = unref(userId);

  return customAxiosInstance<ApiResponseResultResponse>(
    { url: `/api/v7/ai/${userId}/conversations`, method: 'DELETE' },
    options,
  );
};

export const getDeleteV7AiConversationsByUserIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>,
    TError,
    { userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['deleteV7AiConversationsByUserId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return deleteV7AiConversationsByUserId(userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV7AiConversationsByUserIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>
>;

export type DeleteV7AiConversationsByUserIdMutationError = ErrorType<unknown>;

/**
 * @summary 대화 삭제
 */
export const useDeleteV7AiConversationsByUserId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>,
      TError,
      { userId: string },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof deleteV7AiConversationsByUserId>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getDeleteV7AiConversationsByUserIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
